export default __webpack_public_path__ + "static/media/gallery_00.be2d44c9.jpg";